import { makeVar } from '@dustin-web/microsite-components/src/hooks/use-reactive-var'
import { RefObject } from 'react'

export const lastIndexVar = makeVar<number | null>(null)
export const getRefVar = makeVar<RefObject<HTMLDivElement | null> | null>(null)
